<template>
  <div>
    <a-card :bordered="false" class="header-solid h-full mb-50" :bodyStyle="{ paddingTop: '12px', backgroundColor: 'transparent' }" style="background: transparent; box-shadow: none;">
      <template #title>
        <a-row>
          <a-col :xs="24" :sm="24" :md="20" :lg="20" :xl="20">
            <h6 class="font-web f-18"><a @click="gotoMainRequest" class="mr-5">
              <a-icon type="arrow-left" /></a>&nbsp;แบบฟอร์มคำขออนุมัติประเภทต่างๆ
            </h6>
            <p class="font-web mt-0 mb-0 ml-20">&nbsp;&nbsp;Choose a request type to be processed</p>
          </a-col>
          <a-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4"></a-col>
        </a-row>
      </template>
      <a-row :gutter="[24, 24]" type="flex" align="stretch" class="mb-50 mt-20">
        <a-col v-for="(item, cardtype) in dataCardRequest" :key="'type' + cardtype" :xs="12" :sm="8" :md="6" :lg="4" :xl="4">
          <div v-if="hasCommonElement($store.state.role.RulesUser.roles, item.adFRole)" class="gutter-box" style="position: relative; height: 100%;">
            <div v-if="item.statusOpen === 'off'" class="ribbon-2">
              ปิดการใช้งานชั่วคราว
            </div>
            <div 
              class="service-card" 
              @click="gotoFormRequest(item.statusOpen === 'off' ? '/hri/request' : item.path)"
              :class="{ 'card-disabled': item.statusOpen === 'off' }"
            >
              <div class="service-icon-wrapper" :style="{ background: item.statusOpen === 'off' ? '#F1F6F9' : item.color + '1A' }">
                <a-icon
                  :type="item.icon"
                  class="service-icon"
                  :style="{ color: item.statusOpen === 'off' ? '#d9d9d9' : item.color }"
                />
              </div>
              <h3 class="service-card-title font-web" v-html="item.headText"></h3>
              <p class="service-card-desc font-web">{{ item.description }}</p>
            </div>
          </div>
        </a-col>
      </a-row>
    </a-card>
  </div>
</template>

<script>
import cardContent from "./cardtype.js";
export default {
  data() {
    return {
      dataCardRequest: cardContent.items,
    };
  },
  methods: {
    gotoMainRequest() {
      this.$router
        .push({
          path: "/hri",
        })
        .catch((err) => { });
    },
    gotoFormRequest(pathUrl) {
      this.$router
        .push({
          path: pathUrl,
        })
        .catch((err) => { });
    },
    hasCommonElement(arr1, arr2) {
      return arr2.some(item => arr1.includes(item));
    },
    checkRole(arr) {
      if (arr.includes("staff")) {
        return "staff";
      }
      if (arr.includes("faculty")) {
        return "faculty";
      }
      return null;
    }
  },
};
</script>

<style scoped>
.f-20 {
  font-size: 20px;
}

.f-18 {
  font-size: 18px;
}

.f-16 {
  font-size: 16px;
}

.f-14 {
  font-size: 14px;
}

.ribbon-2 {
  --f: 8px;
  --r: 12px;
  --t: 6px;

  position: absolute;
  inset: var(--t) calc(-1*var(--f)) auto auto;
  padding: 0 8px var(--f) calc(8px + var(--r));
  clip-path: polygon(0 0, 100% 0, 100% calc(100% - var(--f)), calc(100% - var(--f)) 100%,
      calc(100% - var(--f)) calc(100% - var(--f)), 0 calc(100% - var(--f)),
      var(--r) calc(50% - var(--f)/2));
  background: #fb1118;
  box-shadow: 0 calc(-1*var(--f)) 0 inset #0005;
  z-index: 10;
  color: #ffffff;
  font-size: 10px;
  font-weight: 700;
  pointer-events: none;
}

/* Service Card Styles from mainportal.vue */
.service-card {
  position: relative;
  background: #fff;
  border-radius: 16px;
  padding: 24px 12px 18px;
  text-align: center;
  cursor: pointer;
  border: 1px solid #eef2f7;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.service-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 28px rgba(24, 144, 255, 0.12);
  border-color: #91d5ff;
}

.service-card.card-disabled {
  opacity: 0.7;
  cursor: not-allowed;
  filter: grayscale(0.5);
}

.service-icon-wrapper {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  transition: transform 0.3s ease;
}

.service-card:hover .service-icon-wrapper {
  transform: scale(1.1);
}

.service-icon {
  font-size: 28px !important;
}

.service-card-title {
  font-size: 16px;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 6px;
  line-height: 1.3;
}

.service-card-desc {
  font-size: 13px;
  color: #9ca3af;
  line-height: 1.4;
  margin: 0;
}
</style>